module.exports = __webpack_public_path__ + "assets/img/title-78f55c26.png";